import { AppState } from "../../../@types";
import {
  createGa4Event,
  createTealiumPageViewPayload,
  createUTagPageView,
  sendTealiumEvent,
  sendTealiumLink,
} from "./helpers";
import {
  AnalyticsActions,
  AnalyticsActionType,
  Ga4Event,
  Ga4EventType,
} from "./types";

export function analyticsReducer(
  state: AppState,
  action: AnalyticsActions
): AppState {
  switch (action.type) {
    case AnalyticsActionType.SEND_GA4_EVENT: {
      const { settings } = action;
      createGa4Event({ state, settings });
      return state;
    }
    case AnalyticsActionType.SEND_BUTTON_ENGAGEMENT_EVENT: {
      const { button, custom = {}, linkUrl = "" } = action.settings;
      createGa4Event({
        settings: {
          custom,
          event_name: Ga4Event.BUTTON_ENGAGEMENT,
          event_type: Ga4EventType.UI_INTERACTION,
          link_url: linkUrl,
          text: button.text,
        },
        state,
      });
      sendTealiumEvent({
        event_action: `engaged ${button.buttonStyle} button`,
        event_label: `${button.text}: ${linkUrl}`,
        other_props: {
          event_category: Ga4EventType.UI_INTERACTION,
        },
      });
      return state;
    }
    case AnalyticsActionType.SEND_INTERNAL_LINK_CLICKED_EVENT: {
      /**
       * Used primarily for links that go to external sites (???)
       * @param custom {object} - Pass custom dimensions for GA4
       * @param custom.link_text {string} - Override link text for UA
       */
      const { custom = {}, linkText, linkUrl = "" } = action.settings;
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { link_text, ...rest } = custom;
      createGa4Event({
        settings: {
          custom: rest,
          event_name: Ga4Event.INTERNAL_LINK_CLICKED,
          event_type: Ga4EventType.UI_INTERACTION,
          link_text: linkText,
          link_url: linkUrl,
        },
        state,
      });
      const uaLinkText = custom?.link_text || `${linkText}: ${linkUrl}`;
      sendTealiumEvent({
        event_action: custom?.event_action || "internal link clicked",
        event_label: uaLinkText,
        other_props: {
          event_category: Ga4EventType.UI_INTERACTION,
        },
      });
      return state;
    }
    case AnalyticsActionType.SEND_TEALIUM_PAGE_VIEW: {
      const props = action.settings;
      createTealiumPageViewPayload({ props, state });
      return state;
    }
    case AnalyticsActionType.SEND_TEALIUM_LINK: {
      const props = action.settings;
      sendTealiumLink(props);
      return state;
    }
    case AnalyticsActionType.SEND_TEALIUM_EVENT: {
      const props = action.settings;
      sendTealiumEvent(props);
      return state;
    }
    case AnalyticsActionType.SEND_UTAG_PAGE_VIEW: {
      const props = action.settings;
      createUTagPageView({ props, state });
      return state;
    }
    default: {
      return state;
    }
  }
}
